import styled from 'styled-components';

import {
  Heading,
  breakpoints,
  ImagePlaceholder,
} from '@notino/react-styleguide';

export const ModalHeader = styled(Heading.H3)`
  text-align: left;
  margin: 0 auto;
`;

export const DiamondIconWrapper = styled.div`
  display: flex;
  flex-basis: 20%;
  height: 100%;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  max-height: 93%;

  @media screen and (min-width: ${breakpoints.md}) {
    flex-direction: row-reverse;
    height: auto;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 2rem 0;

  @media screen and (min-width: ${breakpoints.md}) {
    width: 50%;
  }
`;

export const TextContentWrapper = styled.div`
  display: flex;
  padding: 1rem;

  @media screen and (min-width: ${breakpoints.md}) {
    padding: 2rem;
  }
`;

export const InfoWrapper = styled.div`
  flex-basis: 75%;

  @media screen and (min-width: ${breakpoints.md}) {
    flex-basis: 80%;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;

  @media (min-width: ${breakpoints.md}) {
    align-items: center;
  }
`;

export const StyledImagePlaceholder = styled(ImagePlaceholder)`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
`;
